export default __webpack_public_path__ + "static/media/background.a772b0f2.jpg";